
export const baseURL = "https://fruitloop.gopilive.com/";
// export const baseURL = "http://localhost:5004/";
export const adminBaseURL = "https://rendezvous.gopilive.com/";
export const key = "#TkUM],WEeDr))$FcQlz>EmU4+.f)o";


